import { Button } from "@mui/material";
import { CustomButtonProps } from "../../../utils/buttonFields";
import { FC } from "react";

const CustomButton: FC<CustomButtonProps> = (props) => {
  return (
    <>
      <Button
        disabled={props?.disabled}
        style={{
          ...props.style,
        }}
        sx={{
          textTransform: "capitalize",
          height: "30px",
          cursor: props?.disabled ? "not-allowed" : "pointer",
          ...props?.sx,
        }}
        variant={props?.variant ? props?.variant : "contained"}
        color="secondary"
        onClick={props.onClick}
      >
       {props.icon && <img src={props.icon} alt={props.title} style={{ marginRight: "5px" }} />}
       {props.title}
      </Button>
    </>
  );
};
export default CustomButton;
